import styled from 'styled-components';
import { type DotColors } from './index';

const GAP = 16;
const DOT_FALLBACK_COLOR = '#171717';

export const Slider = styled.div`
  width: 100%;
`;

export const Viewport = styled.div`
  overflow: hidden;
  width: 100%;
  touch-action: pan-y;
  direction: ltr;
`;

export const Track = styled.ul<{ $activeIndex: number }>`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  direction: ltr;
  transform: translate3d(
    calc(${({ $activeIndex }) => `-${$activeIndex}`} * (100% + ${GAP}px)),
    0,
    0
  );
  transition: transform 0.55s cubic-bezier(0.25, 0.1, 0.25, 1);
  will-change: transform;
  gap: ${GAP}px;
`;

export const TrackItem = styled.li`
  flex: 0 0 100%;
  width: 100%;
  min-width: 100%;
  display: flex;
`;

export const Dots = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;
`;

const dotColor = (colors: DotColors | undefined, key: keyof DotColors) =>
  colors?.[key] ?? DOT_FALLBACK_COLOR;

type DotProps = {
  $isActive: boolean;
  $colors?: DotColors;
};

export const Dot = styled.button<DotProps>`
  width: 8px;
  height: 8px;
  padding: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  background-color: ${({ $isActive, $colors }) =>
    dotColor($colors, $isActive ? 'active' : 'inactive')};
  transition:
    background-color 0.3s ease,
    transform 0.3s ease;
  transform: scale(${({ $isActive }) => ($isActive ? 1.15 : 1)});

  &:hover {
    background-color: ${({ $isActive, $colors }) =>
      $isActive ? dotColor($colors, 'active') : ($colors?.hover ?? dotColor($colors, 'inactive'))};
  }
`;
